import React from 'react';
import type { SubscriptionStatus } from '../types';
interface StatusBadgeProps {
  status: SubscriptionStatus;
  displayName: string;
}
export const StatusBadge = ({
  status,
  displayName
}: StatusBadgeProps) => {
  const getStatusStyles = (status: SubscriptionStatus) => {
    switch (status) {
      case 'active':
        return 'bg-[#00CAB7]/10 text-[#00CAB7]';
      case 'inactive':
      case 'not_active':
      case 'incomplete_payment':
      case 'discounted':
      case 'not_subscribed':
        return 'bg-gray-100 text-gray-600';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'cancel_pending':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Override display text for specific statuses
  const getDisplayText = (status: SubscriptionStatus, defaultText: string) => {
    if (['inactive', 'not_active', 'incomplete_payment', 'discounted', 'not_subscribed'].includes(status)) {
      return 'Inactive';
    }
    return defaultText;
  };
  return <span className={`${getStatusStyles(status)} px-2.5 py-0.5 rounded-full text-xs font-medium`} data-id="element-187">
      {getDisplayText(status, displayName)}
    </span>;
};